/*! data-type: scrolltotop, viewport, sticky, scrolled
*   todo: split to separate files, single responsibility each file
* */
(function() {
    'use strict';

    /* scroll eventListener :( */
    var supportsPassive = false;
    try {
        var opts = Object.defineProperty({}, 'passive', {
            get: function() {
                supportsPassive = true;
            }
        });
        window.addEventListener("testPassive", null, opts);
        window.removeEventListener("testPassive", null, opts);
    } catch (e) {}

    /* smooth scroll to anchor */
    function smoothScrollTo(event) {
        // extract hash from url
        let href = this.getAttribute('href');
        let hash = href.split('#')[1];
        if (hash !== "") {
            // find element to scroll to
            var el = document.getElementById(hash);
            if (el) {
                // prevent default anchor click behavior
                event.preventDefault();
                // fix scrollto position behind header
                let header = document.getElementsByTagName('header'), headerHeight = 80;
                if (header.length > 0) {
                    // todo: possible bug, assign width to height? Really?
                    headerHeight = header[0].offsetWidth;
                }
                var to = - headerHeight;
                var from = window.pageYOffset;
                do {
                    to += el.offsetTop;
                    el = el.offsetParent;
                } while (el);
                if (from !== to) {
                    if ('scrollBehavior' in document.documentElement.style) {
                        // new smooth scroll behavior
                        window.scrollTo({ top: to, left: 0, behavior: "smooth" });
                    } else {
                        // fallback ease scroll, by request anaimation frame
                        var start = Date.now();
                        var tick = function () {
                            var t = Math.min(1, ((Date.now() - start) / 1000));
                            var eased = t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1;
                            var val = (eased * (to - from)) + from;
                            window.scrollTo(0, val);
                            if (t<1) {
                                window.requestAnimationFrame(tick);
                            }
                        };
                        tick();
                    }
                }
                // todo: check if it is in use and if it is the right place heare
                document.body.classList.remove('mainmenu-isopen');
            }
        }
    }

    // add event listener to all elements with hash in href
    // that link to another element on same page
    if (!'scrollBehavior' in document.documentElement.style ) {
        let refs = document.querySelectorAll("[href*='#']");
        for (let i = 0; i < refs.length; i++) {
            let href = refs[i].getAttribute('href');
            href = href.replace(window.location.href, '');
            href = href.replace(window.location.pathname, '');
            if (href.indexOf('#') === 0) {
                let id = href.substr(1);
                if (document.getElementById(id)) {
                    refs[i].addEventListener('click', smoothScrollTo);
                }
            }
        }
    }

    /* viewport by observer */
    let viewport = document.querySelectorAll("[data-type='viewport'], .data-viewport");
    if (viewport) {
        let observer = new IntersectionObserver(function(entries) {
                for (let i=0; i < entries.length; i++) {
                    if (entries[i].isIntersecting) {
                        entries[i].target.classList.add('in-viewport');
                    } else {
                        entries[i].target.classList.remove('in-viewport');
                    }
                }
            },
            {
                threshold: [0.1],
                delay: 100
            });
        for (let i=0; i<viewport.length; i++) {
            observer.observe(viewport[i]);
        }
    }

    /* sticky by observer */
    let stickyHeader = document.querySelector("header[data-type='sticky']");
    if (stickyHeader) {
        let observer = new IntersectionObserver(function(entries) {
                if (entries[0].intersectionRatio < 1) {
                    entries[0].target.classList.add('is-sticky');
                } else {
                    entries[0].target.classList.remove('is-sticky');
                }
            },
            {
                threshold: [1]
            });
        var positionSticky = window.getComputedStyle(stickyHeader).getPropertyValue("position");
        let style = window.getComputedStyle(stickyHeader);
        if (positionSticky === 'sticky') {
            stickyHeader.style.top = (parseInt(style.getPropertyValue('top'), 10) -1) + 'px';
            stickyHeader.style.paddingTop = (parseInt(style.getPropertyValue('padding-top'), 10) +1) + 'px';
            observer.observe(stickyHeader);
        } else {
            var scrollPos = 0;
            var marginTop = - window.getComputedStyle(stickyHeader).getPropertyValue("top") || 0;
            var height = style.getPropertyValue('height');
            var main = document.querySelector('main');
            function getScrollPos() {
                let pos = 0;
                var el = stickyHeader;
                do {
                    pos += el.offsetTop;
                    el = el.offsetParent;
                } while(el);
                pos += marginTop;
                if (pos !== 0) {
                    scrollPos = pos;
                }
            }
            function stickyElement() {
                if ((window.scrollY||window.pageYOffset)>scrollPos) {
                    stickyHeader.classList.add('fixed');
                    stickyHeader.classList.add('is-sticky');
                    main.style.marginTop = height;
                } else {
                    stickyHeader.classList.remove('fixed');
                    stickyHeader.classList.remove('is-sticky');
                    main.style.marginTop = '';
                }
            }
            window.addEventListener('scroll', stickyElement, supportsPassive ? {capture: false, passive: true}: true);
            window.addEventListener('resize', function(){ getScrollPos(); stickyElement(); }, supportsPassive ? {capture: false, passive: true}: true);
            getScrollPos();
            stickyElement();
        }
    }


    /*
     * scroll to top
     * Only a single Element allowed with data-type="scrolltotop"
     */
    var scrolltotop = document.querySelector("[data-type='scrolltotop']");
    // add scroll event listener to window, to display scrolltotop button
    // scroll to top is handled by smoothScrollTo
    if (scrolltotop) {
        function scrollToTop (event) {
            let scroll = this ? this.scrollY : window.scrollY;
            let triggerPoint = scrolltotop.dataset.position || 10;
            if (scroll > triggerPoint){
                scrolltotop.dataset.fade = 'in';
            } else {
                scrolltotop.dataset.fade = 'out';
            }
        }
        window.addEventListener('scroll', scrollToTop, supportsPassive ? {capture: false, passive: true} : true);
        if ('scrollBehavior' in document.documentElement.style ) {
            scrolltotop.addEventListener('click', function(){
                window.scrollTo(0, 0);
            });
        } else {
            scrolltotop.addEventListener('click', function(){
                // Smooth scroll fallback for Safari < 15.4
                let start = Date.now();
                let to = 0;
                let from = window.scrollY;
                let tick = function () {
                    var t = Math.min(1, ((Date.now() - start) / 1000));
                    var eased = t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1;
                    var val = (eased * (to - from)) + from;
                    window.scrollTo(0, val);
                    if (t<1) {
                        window.requestAnimationFrame(tick);
                    }
                };
                tick();
            });
        }
        scrollToTop();
    }

    /* scrolled */
    // add class scrolled to element if window is scrolled
    const scrolled = document.querySelectorAll('[data-type="scrolled"]');

    const isScrolled = () => {
        let value = (window.scrollY||window.pageYOffset) > 0;
        for (let i=0; i < scrolled.length; i++) {
            if (value) {
                scrolled[i].classList.add('scrolled');
            } else {
                scrolled[i].classList.remove('scrolled');
            }
        }
    };

    if (scrolled.length > 0) {
        window.addEventListener('scroll', isScrolled, supportsPassive ? {capture: false, passive: true}: true);
    }
})();
